/* eslint-disable */
import axios from 'axios'

let myurl = ''
// html转换
let reEscapedHtml = /(&amp;|&lt;|&gt;|&quot;|&#39;)/g
let htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
}

function unescapeHtmlChar(match) {
  return htmlUnescapes[match]
}

function HtmlDecode(string) {
  return string == null ? '' : String(string).replace(reEscapedHtml, unescapeHtmlChar)
}

// 模态窗口
var ModalLoading = '<div class="am-modal am-modal-loading am-modal-no-btn" tabindex="-1" id="http-modal-loading">' +
  '<div class="am-modal-dialog">' +
  '<div class="am-modal-hd">正在载入...</div>' +
  '<div class="am-modal-bd">' +
  '<span class="am-icon-spinner am-icon-spin"></span>' +
  '</div>' +
  '</div>' +
  '</div>'
$('body').append(ModalLoading)
// alert窗口
var ModalAlert = '<div class="am-modal am-modal-alert" tabindex="-1" id="my-alert1">' +
  '<div class="am-modal-dialog">' +
  '<div class="am-modal-bd" id="alert-msg">' +
  'Hello world！' +
  '</div>' +
  '<div class="am-modal-footer">' +
  ' <span class="am-modal-btn">确定</span>' +
  '</div>' +
  '</div>' +
  '</div>'
$('body').append(ModalAlert)
let alert = function (str) {
  $('#alert-msg').html(str)
  $('#my-alert1').modal('open')
}

function jsonPD(data) {
  let ret = false
  if (parseInt(data.code) === 0) {
    ret = true
  } else {
    if (data.msg !== '未登录！') {
      alert(data.msg)
    } else {
      console.log(data.msg)
    }
  }
  return ret
}

function ajaxGet(url) {
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.get(url).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

function ajaxGetconfig(url, config) {
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.get(url, config).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 获取保证金列表
function getBzjlist() {
  return ajaxGet(myurl + '/RESTfull/bzjgg/bzjggrq.json')
}

// 获取交易所列表
function getJyslist() {
  return ajaxGet(myurl + '/RESTfull/gsgg/jys/list.json')
}

// 获取公司公告列表
function getGsgglist() {
  return ajaxGet(myurl + '/RESTfull/gsgg/list.json')
}

// 获取自助问答列表
function getZzwdlist() {
  return new Promise(function (resolve) {
    ajaxGet(myurl + '/RESTfull/zzwd/zzwdlist.json').then(
      data => {
        let list = []
        data.forEach((item) => {
          item.list.forEach((qa) => {
            list.push({
              title: qa.q,
              value: '<header style="font-size: 26px;font-weight: bold;color: #323232;text-align: center">' + qa.q + '</header>' + HtmlDecode(qa.a)
            })
          })
        })
        resolve(list)
      }
    )
  })
}

// 获取文章
function getWz(url) {
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.get(myurl + url).then(
      m => {
        $('#http-modal-loading').modal('close')
        resolve(m.data)
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 获取投资者教育文章
function getTzzjy(str) {
  return ajaxGet(myurl + '/RESTfull/tzjy/' + str + '/list.json')
}

// 意见反馈
function yjfk(senddata) {
  return ajaxGetconfig('/RESTfull/yjfk/saveYj.do', { params: senddata })
}

// 获取管理人员
function getGlry() {
  return ajaxGet(myurl + '/RESTfull/gywm/glry.json')
}

// 获取从业人员
function getCyry() {
  return ajaxGet(myurl + '/RESTfull/gywm/cyry.json')
}

// 获取从业人员
function getCwxx() {
  return ajaxGet(myurl + '/RESTfull/gywm/cwxx.json')
}

// 获取从业人员
function getLsqk() {
  return ajaxGet(myurl + '/RESTfull/gywm/lsqk.json')
}

// 登录
function login(senddata) {
  // return ajaxGetconfig('/RESTfull/user/login.do', { params: senddata })
  var url = '/RESTfull/user/login.do'
  var config = senddata
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.post(url, config).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 登出
function logout() {
  return ajaxGet('/RESTfull/user/logout.do')
}

// 是否登录
function islogin() {
  return ajaxGet('/RESTfull/user/islogin.do')
}

// 重置密码
function resetpwd(senddata) {
  // return ajaxGetconfig('/RESTfull/user/resetpwd.do', { params: senddata })
  var url = '/RESTfull/user/resetpwd.do'
  var config = senddata
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.post(url, config).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 找回密码
function updPassword(senddata) {
  // return ajaxGetconfig('/RESTfull/user/updPassword.do', { params: senddata })
  var url = '/RESTfull/user/updPassword.do'
  var config = senddata
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.post(url, config).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 注册
function register(senddata) {
  // return ajaxGetconfig('/RESTfull/user/register.do', { params: senddata })
  var url = '/RESTfull/user/register.do'
  var config = senddata
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.post(url, config).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 发送验证码
function sendCode(senddata) {
  // return ajaxGetconfig('/RESTfull/user/sendCode.do', { params: senddata })
  var url = '/RESTfull/user/sendCode.do'
  var config = senddata
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.post(url, config).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (jsonPD(m.data)) {
          resolve(m.data)
        } else {
          reject(m.data.msg)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 获取资产管理公告
function getCfgllist() {
  return new Promise(function (resolve) {
    ajaxGet(myurl + '/RESTfull/cfglzx/gg/gg.json').then(
      data => {
        data.forEach((item) => {
          item.value = item.url
        })
        resolve(data)
      }
    )
  })
}

// 获取资产基金分类
function getCfglJjfl() {
  return ajaxGet(myurl + '/RESTfull/cfglzx/jjfl.json')
}

// 获取资产基金
function getJjList(jjfl) {
  let ajaxlist = []
  jjfl.list.forEach((item) => {
    ajaxlist.push(ajaxGet(myurl + '/RESTfull/cfglzx/jj/' + jjfl.type + '/' + item.type + '.json'))
  })
  return Promise.all(ajaxlist)
}

// 获取资产概况
function getJjgk(id) {
  return new Promise(function (resolve, reject) {
    ajaxGet(myurl + '/RESTfull/cfglzx/xq/' + id + '.json').then(
      m => {
        if (!m.hasOwnProperty('gk')) {
          m.gk = [
            { ljjz: '1', time: '基金净值未录入', ljnh: '0', dwjz: '1' }
          ]
        }
        resolve(m)
      }
    )
  })
}

// 获取资产管理文章
function getzcglWz(url) {
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.get(myurl + url).then(
      m => {
        $('#http-modal-loading').modal('close')
        if (parseInt(m.data.code) !== 0) {
          reject(m.data.msg)
        } else {
          resolve('<h1>' + m.data.data.title + '</h1>' + m.data.data.content)
        }
      }
    ).catch(function (err) {
      $('#http-modal-loading').modal('close')
      console.log(err)
      reject(err)
    })
  })
}

// 获取子公司信息
function getZGSMes() {
  return ajaxGet('/RESTfull/gywm/gsnr.json')
}

// 获取其他公示
function getQTGS() {
  return ajaxGet('/RESTfull/gywm/qtgs.json')
}

// 获取股东信息
function getGDXX() {
  return ajaxGet('/RESTfull/gywm/gdxx.json')
}

// 获取公司信息
function getGSXX() {
  return ajaxGet('/RESTfull/gywm/gsxx.json')
}

// 获取诚信记录
function getCXJL() {
  return ajaxGet('/RESTfull/gywm/cxjl.json')
}

// 获取分支机构
function getFZJG() {
  return ajaxGet('/RESTfull/gywm/fzjg.json')
}
/* eslint-disable */
// 获取在线客服路径
function getOnline() {
  var url = '/RESTfull/zxkf/url.json'
  var config = { pageType: '0' }
  return new Promise(function (resolve, reject) {
    $('#http-modal-loading').modal('open')
    axios.post(url, config).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
// 靓号随行获取验证码
function sendCodeLhsx(senddata) {
  var url = '/Service/public/sendVerifyCode.do?mobile=' + senddata.mobile + '&type=1003'
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
function publicGetExchcommrateByContract(contract) {
  var url = '/Service/public/getExchcommrateByContract?contract=' + contract
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
// 靓号随行提交申请
const qs = require('qs');
function loginLhsx(senddata, tecentAdvertData = '') {
  var url = '/Service/recommand/add'
  var config = senddata
  return new Promise(function (resolve, reject) {
    axios.post(url, qs.stringify({ code: config, tecentAdvertData: JSON.stringify(tecentAdvertData) })).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

// 获取下载地址
function getAppDownloadConfig() {
  var url = '/Service/public/getAppDownloadConfig'
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
// 提交开户注册信息
function memberLoginByVerifyCode(mobile, verifyCode, deviceId, brokerSec, clientName, proID) {
  var url = `/Service/public/memberLoginByVerifyCode.do?mobile=${mobile}&verifyCode=${verifyCode}&deviceId=${deviceId}&brokerSec=${brokerSec}&clientName=${clientName}&proID=${proID}`
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
//获取图片验证码
function getImageverificationCode() {

  var url = '/Service/point/getImageverificationCode'
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
// 获取验证码
function sendVerifyCode(senddata) {
  var url = '/Service/public/sendVerifyCode.do?mobile=' + senddata.mobile + '&type=' + senddata.type
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

//直播申请积分
function byListBroadcast(info) {
  var url = '/Service/point/byListBroadcast'
  return new Promise(function (resolve, reject) {
    axios.post(url, info).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
//判断是否进入页面
function getTimeIsOver(liveBroadcast) {
  var url = '/Service/pointService/public/getTimeIsOver?liveBroadcast=' + liveBroadcast
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}
function simulatedApplicationAccount(vo) {
  var url = '/Service/simulated/applicationAccount?phoneNumber=' + vo.phoneNumber + '&code=' + vo.verifyCode + '&clientName=' + vo.clientName + '&source=' + vo.source
  return new Promise(function (resolve, reject) {
    axios.post(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

//
function applicationAccountSimnow(vo) {
  var url = '/Service/simulated/applicationAccountSimNow?phoneNumber=' + vo.phoneNumber + '&code=' + vo.verifyCode + '&clientName=' + vo.clientName + '&source=' + vo.source
  return new Promise(function (resolve, reject) {
    axios.post(url).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

/*
brokerSec 加密信息
clientMobile 被推荐人手机号
clientName 被推荐人姓名
mobile 被推荐人手机号
proID 获客来源 如果是期货app则 'APA03'
verifyCode 验证码 */
// 提交开户注册信息
function futuresAppRecommenderInformationSubmit(mobile, verifyCode, brokerSec, clientName, proID) {
  var url = `/Service/recommand/futuresAppRecommenderInformationSubmit`
  return new Promise(function (resolve, reject) {
    axios.post(url, `mobile=${mobile}&verifyCode=${verifyCode}&brokerSec=${brokerSec}&clientName=${clientName}&proID=${proID}`).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

function application(mobile, source, verifyCode) {
  // ?mobile=${mobile}&source=${source}&verifyMobile=${mobile}&verifyCode=${verifyCode}
  var url = `/Service/pointService/public/futures/fundamentals/application`
  // var config = senddata
  const formData = new FormData()
  formData.append('mobile', mobile)
  formData.append('source', source)
  formData.append('verifyCode', verifyCode)
  formData.append('verifyMobile', mobile)
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
  return new Promise(function (resolve, reject) {
    axios.post(url, formData, config).then(
      m => {
        resolve(m)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

function ruralPlaningResearch(senddata) {
  const url = `/Service/lhmj/ruralPlaningResearch`
  return new Promise(function (resolve, reject) {
    axios.post(url, senddata).then(
      m => {
        resolve(m.data)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}



export default {
  getBzjlist,
  getJyslist,
  getGsgglist,
  getZzwdlist,
  getWz,
  getTzzjy,
  yjfk,
  getGlry,
  getCyry,
  getCwxx,
  getLsqk,
  login,
  logout,
  resetpwd,
  updPassword,
  register,
  sendCode,
  islogin,
  getCfgllist,
  getCfglJjfl,
  getJjList,
  getJjgk,
  getzcglWz,
  getZGSMes,
  getQTGS,
  getGDXX,
  getGSXX,
  getCXJL,
  getFZJG,
  getOnline,
  sendCodeLhsx,
  loginLhsx,
  publicGetExchcommrateByContract,
  getAppDownloadConfig,
  memberLoginByVerifyCode,
  sendVerifyCode,
  simulatedApplicationAccount,
  applicationAccountSimnow,
  getImageverificationCode,
  getTimeIsOver,
  byListBroadcast,
  futuresAppRecommenderInformationSubmit,
  application,
  ruralPlaningResearch
}



// WEBPACK FOOTER //
// ./src/common/ajax/ajax.js